<template>
    <div class="upgradetopremiummodalmessage">
      <div class="upgradetopremium">
        <v-card class="mx-auto normal-card">
          <div class="upgradetopremium">
            <div>
              <v-icon color="red">mdi-alert-circle</v-icon>
            </div>
            <div class="upgradetopremiummodal">
              <div>Sorry!</div>
              <div>{{data}}</div>
              <div>
                Please contact us at <a class="italics-styling"
                                        href="mailto: hello@eduracle.com"
                                    >hello@eduracle.com</a> to get access to these tests.
              </div>
            </div>
          </div>
        </v-card>
      </div>
    </div>
</template>
<script>
export default {
 name: 'UpgradeTestModal',   
 props:['data'],
  data () {    
     return {
       
     }
  }  
}
</script>